module.exports = __webpack_public_path__ + "static/media/blink.a2cf9998.mp3";